<template>
	<div>
		<iframe :src="liveSrc" border="none" class="player"></iframe>
	</div>
</template>

<script>
	import wxapi from '@/common/wxapi.js'
	export default{
		data(){
			return{
				liveSrc: ''
			}
		},
		created(){
			let that = this
			//判断是否授权登录
			if(localStorage.getItem('userId') == null){
				localStorage.setItem('beforeUrl', location.href.split('&')[0])
				that.$router.push({path: '/author'})
			}
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let liveID = window.location.href.split('=')[1].replace('&from','')
			let formdata = new FormData();
			formdata.append('token', localStorage.getItem('token'));
			formdata.append('user_id', localStorage.getItem('userId'));
			formdata.append('live_id', liveID);
			that.$axios.post('http://sls.zhishen.net.cn/api/Live/liveDeatils', formdata)
			.then(function (res){
				// 分享去除微信默认参数
				if (/from=[^&$?]{1,}(&|$)/.test(location.search) || /isappinstalled=[^&$?]{1,}(&|$)/.test(location.search)) {
					let newSearch = location.search.replace(/from=[^&$?]{1,}(&|$)/, '').replace(/isappinstalled=[^&$?]{1,}(&|$)/, '').replace(/&$|\?$/, '');
					let newUrl = location.origin + location.pathname + newSearch + location.hash;
					location.replace(newUrl);
					let option = {
						title: '读联',
						link: newUrl,
						imgUrl: 'http://sl.zhishen.net.cn/static/images/logo.png',
						desc: '读联'
					}
					wxapi.wxRegister(option)
				}else{
					let option = {
						title: '读联',
						link: location.href.split('&')[0],
						imgUrl: 'http://sl.zhishen.net.cn/static/images/logo.png',
						desc: '读联'
					}
					wxapi.wxRegister(option)
				}
				if(res.data.live_detail.button_status == 3 || res.data.live_detail.button_status == 4){
					that.liveSrc = 'https://live.polyv.cn/watch/' + res.data.live_detail.live_polyv_id + '?name=' + res.data.nickname
				}else{
					that.$toast({duration: 1000,message: '购买后可观看'});
					window.location.href = that.login.pageUrl + '/onlivedetail?ID=' + window.location.href.split('=')[1].replace('&from','');
				}
			}).catch(function(error){
				console.log(error)
			})
		}
	}
</script>

<style>
	.player{width: 99vw;height: 99vh;border: none;}
</style>



// WEBPACK FOOTER //
// src/view/live/live.vue